<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container grid-list-md>
      <!-- Organisation -->
      <v-autocomplete
        v-model="form.organisation"
        :items="selectData.organisationSelect"
        @input="organisationSelected"
        :rules="[v => !!v || 'Organisation is Required']"
        label="Organisation"
        item-text="companyname"
        return-object
        required
      ></v-autocomplete>
      <!-- Project Group -->
      <v-autocomplete
        v-if="form.organisation"
        v-model="form.projectGroup"
        :items="selectData.projectGroupSelect"
        @input="projectGroupSelected"
        :rules="[v => !!v || 'Project Group is Required']"
        label="Project Group"
        item-text="groupname"
        return-object
        required
      ></v-autocomplete>
      <!-- Device Type -->
      <v-autocomplete
        v-if="form.projectGroup"
        v-model="form.deviceType"
        :items="selectData.deviceTypeSelect"
        @input="deviceTypeSelected"
        :rules="[v => !!v || 'Device Type is Required']"
        label="Device Type"
        item-text="typename"
        return-object
        required
      ></v-autocomplete>
      <!-- Device -->
      <v-autocomplete
        v-if="form.deviceType"
        v-model="form.device"
        :items="selectData.deviceSelect"
        :rules="[v => !!v || 'Device is Required']"
        label="Device"
        item-text="devicename"
        return-object
        required
      ></v-autocomplete>
      <!-- Date Pickers -->
      <SelectDates
        v-if="form.device"
        @updateDates="onDatesUpdate"
        :days="days"
      />
      <v-btn :disabled="!valid" color="success" @click="validate">Generate Report</v-btn>
      <v-btn color="error" @click="reset">Reset Form</v-btn>
    </v-container>
  </v-form>
</template>

<script>
import moment from 'moment'
import SelectDates from './SelectDates'
export default {
  name: 'SelectDeviceForm',
  components: { SelectDates },
  props: {
    allowAllDevices: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    error: false,
    valid: true,
    form: {
      organisation: null,
      projectGroup: null,
      deviceType: null,
      device: null,
      dateFrom: null,
      dateTo: null
    },
    selectData: {
      organisationSelect: [],
      projectGroupSelect: [],
      deviceTypeSelect: [],
      deviceSelect: []
    },
    days: 7
  }),
  methods: {
    onDatesUpdate (dateto, datefrom) {
      this.form.dateTo = moment(dateto).format('YYYYMMDD235959')
      this.form.dateFrom = moment(datefrom).format('YYYYMMDD000000')
    },
    validate () {
      if (this.$refs.form.validate()) {
        this.$emit('validate', this.form)
      }
    },
    reset () {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    },
    requestFailed () {
      this.error = 'Failed to retrieve report data.'
    },
    organisationSelected () {
      if (this.form.organisation) {
        this.$http
          .get('/schemas/projectgroups?parentid=' + this.form.organisation.id)
          .then(response => {
            this.selectData.projectGroupSelect = response.data.projectgroups
          })
          .catch(() => this.requestFailed())
      }
    },
    projectGroupSelected () {
      if (this.form.projectGroup) {
        this.$http
          .get('/schemas/devicetypes?parentid=' + this.form.projectGroup.id)
          .then(response => {
            this.selectData.deviceTypeSelect = response.data.devicetypes
          })
          .catch(() => this.requestFailed())
      }
    },
    deviceTypeSelected () {
      if (this.form.deviceType) {
        this.$http
          .get('/schemas/devices?parentid=' + this.form.deviceType.id)
          .then(response => {
            this.selectData.deviceSelect = response.data.devices
            if (this.allowAllDevices) {
              this.selectData.deviceSelect.unshift({
                devicename: 'All'
              })
            }
          })
          .catch(() => this.requestFailed())
      }
    }
  },
  beforeMount () {
    // Get the Orgs and pre-select first value[0]
    this.$http
      .get('/schemas/organisations')
      .then(response => {
        this.selectData.organisationSelect = response.data.organisations
        if (this.selectData.organisationSelect.length > 0) {
          this.form.organisation = this.selectData.organisationSelect[0]
          this.organisationSelected()
        }
      })
      .catch(() => this.requestFailed())
  }
}
</script>
